<template>
	<sf-data-table
		ref="partTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="partList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="650px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/AsPartPopup/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '150px',
					clickEvent: this.scrNameClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '250px'
				},
				{
					label: this.getMessage_('QWCC001096'), //OP코드
					prop: 'opCd',
					minWidth: '180px',
					form: {
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001807'), //OP코드명
					prop: 'opNm',
					minWidth: '180px',
					form: {
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001167'), //시작일
					prop: 'strtDd',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('QWCC001190'), //AS부품가
					prop: 'asCst',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001189'), //PWA여부
					prop: 'pwaYn',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001188'), //HTWO 보증조건
					minWidth: '300px',
					sortable: false,
					children: [
						{
							label: this.getMessage_('QWCC001053'), //사용기간
							prop: 'usePrd',
							width: '150px',
							sortable: false
						},
						{
							label: this.getMessage_('QWCC000972'), //주행거리
							prop: 'milg',
							width: '150px',
							sortable: false
						}
					]
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		scrNameClick(row) {
			this.$emit('SendPartData', row);
		}
	}
};
</script>

<style></style>
